import Text from "../../../design-system/primitives/components/Text/Text";
import Accordion from "../../../design-system/primitives/components/Accordion/Accordion";
import type { HandbookFaqEntry } from "../../../api/handbook";
import HandbookColumn from "./HandbookColumn";

type Props = {
  faq: HandbookFaqEntry[];
};

/** The handbook's FAQ section, edited in Sanity — one open at a time. */
const HandbookFaq = ({ faq }: Props) => (
  <HandbookColumn>
    <Accordion
      items={faq.map(({ key, question, answer }) => ({
        value: key,
        trigger: question,
        content: (
          <Text variant="body" color="neutral-100">
            {answer}
          </Text>
        ),
      }))}
    />
  </HandbookColumn>
);

export default HandbookFaq;
